module.exports = __webpack_public_path__ + "img/chris (28).f6ec004d.jpg";